import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ForgotComponent } from './forgot.component';
import { ForgotRoutingModule } from './forgot-router.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormFieldModule } from 'src/app/_shared/components/form-field';
import { MessageModule } from 'src/app/_shared/components/message';
import { SpinnerComponent } from 'src/app/_shared/components/spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ForgotComponent],
  imports: [
    CommonModule,
    ForgotRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FormFieldModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzButtonModule,
    SpinnerComponent,
    FormFieldModule,
    MessageModule,
    NzIconModule,
    NzButtonModule,
  ],
})
export class ForgotModule {}
